export const buildFavoriteItemPatch = (itemIds) => {
  const patchData = {
    data: {
      type: "current-user",
      attributes: {
        "favorite-item-ids": itemIds,
      },
    },
  };

  return patchData;
};

export const buildDashboardOptionPatch = (option) => {
  const patchData = {
    data: {
      type: "dashboard-option",
      attributes: {
        position: option.isActive ? option.position : 0,
        "display-name": option.displayName,
        "is-active": option.isActive,
      },
    },
  };

  return patchData;
};
